export default "__VITE_ASSET__9r6VwL0w__"